import Admin from './admin.webp';
import Delete from './delete.webp';
import Fact from './fact.webp';
import Input from './input.webp';
import Map from './map.webp';
import Navbar from './navbar.webp';
import Profile from './profile.webp';

export default {
    Admin,
    Delete,
    Fact,
    Input,
    Map,
    Navbar,
    Profile
}